import _ from "lodash";
import TextFieldWithIcon from "./TextFieldWithIcon";
import { Tooltip, IconButton } from "@mui/material";
import { FileCopy } from "@mui/icons-material";
import { colors } from "../pages/css components/Style";
import { useDispatch } from "react-redux";
import { alert } from "../redux/slices/alertSlice";

export default function TextFieldWithCopy(props) {
  const dispatch = useDispatch();
  return (
    <TextFieldWithIcon
      {...props}
      icon={
        <Tooltip title={"Copy " + props.label}>
          <IconButton
            style={{ padding: 0, margin: "12px", color: colors.purple }}
            onClick={() => {
              navigator.clipboard.writeText(
                props.value || _.get(props.formikProps.values, props.name)
              );

              dispatch(
                alert({
                  type: "success",
                  message: "Copied to clipboard",
                })
              );
            }}
          >
            <FileCopy fontSize="small" />
          </IconButton>
        </Tooltip>
      }
    />
  );
}
